"use client";
import { useEffect } from "react";
import { useModalContext } from "@/contexts/ModalProvider";
import { useMonarchData } from "@/monarch/MonarchResolver";
import type { MultiCartTestResult } from "@/monarch/rules/multiCart/types";
import CartModal from "../CartModal";
import { defaultData, getDefaultModalSubHeader } from "./constants";

export default function WelcomeBackModal() {
  const { showWelcome, getTotalItems, setWelcomeBackModalEnabled } =
    useModalContext();
  const testResult = useMonarchData<MultiCartTestResult>("useMultiCart");

  useEffect(() => {
    if (testResult?.data?.welcomeBackModal?.enabled) {
      setWelcomeBackModalEnabled(true);
    }
  }, [setWelcomeBackModalEnabled, testResult]);

  if (!showWelcome || !testResult?.data?.welcomeBackModal) {
    return null;
  }

  const itemCount = getTotalItems();

  const { welcomeBackModal } = testResult.data;
  const subHeader =
    welcomeBackModal.modalSubHeader || getDefaultModalSubHeader(itemCount);

  return (
    <CartModal
      modalData={welcomeBackModal}
      defaultData={defaultData}
      subHeader={subHeader}
    />
  );
}
